module.exports = __webpack_public_path__ + "static/media/pullman03.32e9d94d.jpg";